import React, { useEffect, useState } from "react";
import {
  FaAlignJustify,
  FaAngleLeft,
  FaRegBell,
  FaRegTimesCircle,
  FaSquare,
  FaTimes,
  FaUserCircle,
  FaUserFriends,
} from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import {
  FaAngleRight,
  FaClipboardCheck,
  FaClock,
  FaListCheck,
  FaRankingStar,
  FaUser,
} from "react-icons/fa6";
import { IoExitOutline } from "react-icons/io5";
import { getUser } from "../../api/getUser";
import {
  useAppKit,
  useAppKitAccount,
  useDisconnect,
} from "@reown/appkit/react";
import NewsModal from "../common/modals/NewsModal";
const Navbar = ({
  admin,
  notifOpen,
  notifications,
  setNotifOpen,
  markAsRead,
}) => {
  const [show, setShow] = useState();
  const [data, setdata] = useState();
  const location = useLocation();
  const { open, close } = useAppKit();
  const { address, isConnected, caipAddress, status, embeddedWalletInfo } =
    useAppKitAccount();

  const { disconnect } = useDisconnect();
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (address) {
      updateAddress();
    }
  }, [address]);

  async function updateAddress() {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await httpReauest(
      "POST",
      "/user/wallet/" + user._id,
      { wallet: address },
      { "x-access-token": user?.token }
    );
  }

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await getUser(user?._id).catch(() => {
      localStorage.removeItem("user");
      window.location.href = window.origin;
    });
    if (res?.baned) {
      navigate("/baned");
    }
    setdata(res);
  }

  async function handleDelete() {
    localStorage.setItem("user", null);
    if (isConnected) {
      await disconnect();
    }

    window.location.href = window.origin;
  }

  const shortenAddress = (address, startLength = 6, endLength = 4) => {
    if (!address) return "";
    return `${address.slice(0, startLength)}...${address.slice(-endLength)}`;
  };

  return (
    <>
      {data && !data?.checkNews && <NewsModal />}
      <span className="fixed top-0  w-full h-14 bg-[#4A5A69] p-4 z-20 border-b border-white/50 col-span-full lg:hidden text-white flex justify-between items-center">
        <span class="flex items-center text-white gap-3 text-[18px] justify-center mb-2 pt-3">
          <img
            src="https://www.filetrust.io/img/Logo_white.svg"
            class="w-8"
            alt="Logo"
          />
          <h1>FileTrust</h1>
        </span>
        <span className="flex gap-2 items-center">
          <button
            onClick={() => setNotifOpen((prev) => !prev)}
            className="px-3 relative rounded-full flex gap-2 text-white items-center transition-all duration-200 text-xl font-semibold"
          >
            <FaRegBell />
            {notifications.some((n) => !n.read) && (
              <span className="absolute w-4 h-4 flex items-center justify-center top-0 right-0 bg-red-500 text-white text-[10px] px-1 rounded-full">
                {notifications.filter((n) => !n.read).length}
              </span>
            )}
          </button>

          {notifOpen && (
            <div className="absolute right-2 top-10 w-[300px] max-h-[350px] overflow-auto text-white rounded shadow-lg z-[59]">
              {notifications.length === 0 ? (
                <div className="p-4 text-center text-gray-500">
                  No Notification
                </div>
              ) : (
                <ul>
                  {notifications.map((n) => (
                    <li
                      key={n._id}
                      className={`border-b border-gray-900 p-3 ${
                        !n.read ? "bg-[#4b5c70]" : "bg-[#1E2B3B]"
                      }`}
                    >
                      <div className="font-semibold">{n.title}</div>
                      <div className="text-sm mb-2">{n.message}</div>
                      {!n.read && (
                        <button
                          onClick={() => markAsRead(n._id)}
                          className="text-red-600 text-sm font-bold hover:underline"
                        >
                          check as read
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}

          <FaAlignJustify
            size={20}
            className=""
            onClick={() => setShow(true)}
          />
        </span>
      </span>
      <div
        className={`min-h-[100vh] bg-[#1E2B3B] lg:rounded-r-[40px] w-full h-full  z-50 lg:shadow-2xl flex absolute flex-col justify-between py-4 lg:relative ${
          show ? "left-0 " : "left-full lg:left-0"
        } duration-200 `}
      >
        <div className="px-4">
          <span>
            <FaTimes
              size={20}
              className="lg:hidden absolute left-2 top-4 text-white"
              onClick={() => setShow(false)}
            />
          </span>
          <span class="flex items-center text-white gap-3 text-[30px] w-full justify-center mb-2 pt-3">
            <img
              src="https://www.filetrust.io/img/Logo_white.svg"
              class="w-12 lg:w-14"
              alt="Logo"
            />
            <h1>FileTrust</h1>
          </span>

          <div className="flex flex-col  pt-8  text-white gap-3">
            <Link
              onClick={() => setShow(false)}
              className={`${
                location.pathname === "/dashboard" && "active-nav-link"
              } flex justify-start text-[22px] gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative nav-link`}
              to="/dashboard"
            >
              <FaUser size={34} /> Profile
            </Link>
            <Link
              onClick={() => setShow(false)}
              className={`${
                location.pathname === "/daily" && "active-nav-link"
              } flex justify-start text-[22px] gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative nav-link`}
              to="/daily"
            >
              <FaClock size={34} /> Daily Reward
            </Link>
            <Link
              onClick={() => setShow(false)}
              className={`${
                location.pathname === "/tasks" && "active-nav-link"
              } flex justify-start text-[22px] gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative nav-link`}
              to="/tasks"
            >
              <FaClipboardCheck size={34} /> Tasks
            </Link>
            <Link
              onClick={() => setShow(false)}
              className={`${
                location.pathname === "/leaderboard" && "active-nav-link"
              } flex justify-start text-[22px] gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative nav-link`}
              to="/leaderboard"
            >
              <FaRankingStar size={34} /> Leaderboard
            </Link>
            <Link
              onClick={() => setShow(false)}
              className={`${
                location.pathname === "/friends" && "active-nav-link"
              } flex justify-start text-[22px] gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative nav-link`}
              to="/friends"
            >
              <FaUserFriends size={34} /> Invite friends
            </Link>
          </div>
        </div>

        <div className="border-t-2 px-4">
          {data?.wallet ? (
            <button
              className={` flex justify-center text-white text-[22px] gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative  mt-2 mb-1`}
            >
              {shortenAddress(data?.wallet)} <FaUserCircle size={38} />
            </button>
          ) : (
            <button
              onClick={() => open()}
              className={` flex justify-center text-white text-[22px] gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative  mt-2 mb-1`}
            >
              Connect wallet <FaUserCircle size={38} />
            </button>
          )}{" "}
          <button
            onClick={handleDelete}
            className={`flex justify-center text-white text-[22px] w-full gap-4 items-center px-3 rounded-[16px] duration-200 py-3 font-[600] relative nav-link`}
          >
            Logout{" "}
            <span className="bg-white rounded-full p-1.5 text-[#02006A]">
              <IoExitOutline size={22} />
            </span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;
